export default "__VITE_ASSET__e7dfb080__"